// extracted by mini-css-extract-plugin
module.exports = {"row":"_2reu-nhVDgJ3f7TFOC20nf","col":"_3ykwWhK1msbIkFN_-FTNwG","colAbout":"_1v11JWrJi24HX_fclwYkn2","colLearn":"_2wAA5AbL7dzKTfIrjN1hY5"};